<template>

  <div style=" display: flex;
    flex-direction: column; justify-content: center;">

    <div class="title" style="height: 150px; display: flex;
    justify-content: center;">
      <H2>账号管理</H2>
    </div>

    <div style=" display: flex;
    justify-content: center;     height: 100px;     margin: 0px 45px;">
      <div>
        <el-form :model="form1">
          <el-form-item label="说明：" >
            {{ jieshao }}
          </el-form-item>
          <el-divider content-position="left" style="color: red;">---- 验证项 ----</el-divider>
          <hr/>
          <el-form-item label="账号" >
            <el-input v-model="form1.username" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" >
            <el-input v-model="form1.password" type="password" show-password autocomplete="off"></el-input>
          </el-form-item>

          <hr/>

        </el-form>

        <div slot="footer" style="display: flex;">
            <el-button type="primary" @click="verify">验 证</el-button>
          </div>

        <el-form :model="form2">

            <div style="margin-top: 40px;"><el-divider content-position="left" style="color: red; ">---- 下方操作项（验证完成后进行） ----</el-divider></div>
            <div style="margin-top: 10px;"><el-divider content-position="left" style="color: red; ">---- 有疑问点击<i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>查看说明  ----</el-divider></div>
            
            <hr/>

            <div style="margin-bottom: 30px; margin-top: 20px; width: 50%;">
              <el-button type="primary" @click="rzcx">查看挂号记录</el-button>
            </div>

            <el-form-item label="剩余挂号天数：" >
              {{form2.remainingDays}} {{ tishi }}
            </el-form-item>

            <el-form-item label="是否挂号：" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">当晚不需要挂号可以取消勾选</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
              <el-checkbox v-model="form2.enabled"></el-checkbox>
            </el-form-item>

            <el-form-item label="修改账号：" >
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">谨慎操作，当需要换号时，填写新账号<br/>换号后请把新账号发给管理员，以免影响后续续费提醒</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>
              <el-input v-model="form2.username" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="修改密码：" >
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">修改密码时填写新密码</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>
              <el-input v-model="form2.password" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="修改区服（xx山xx服）：" >
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">修改区服时填写新区服</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>
              <div style="display: flex;">
                <el-input v-model="form2.serverName" autocomplete="off" style="margin-right: 10px;"></el-input>
                <span>
                  <el-tooltip class="item" effect="light" placement="top-start">
                    <div slot="content">{{ form2.serverName }}开服时间：{{ form2.serverOpenTime }}</div>
                    <i class="el-icon-time" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>
              </div>
            </el-form-item>

            <el-form-item label="自动异兽入侵" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认不开启，需要开启请勾选，自动挑战异兽入侵">
                    <div slot="content">默认不开启，需要开启请勾选，自动异兽入侵</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="form2.invadeEnabled"></el-checkbox>
            </el-form-item>

            <el-form-item label="异兽入侵挑战分身" v-if="form2.invadeEnabled">
                <div style="display: flex;">
                  <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="选择异兽入侵挑战分身，默认元体">
                    <div slot="content">选择异兽入侵挑战分身，默认元体</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-select v-model="form2.invadeIndex" collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in invadeIndexList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>

            <el-form-item label="自动星宿试炼" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认不开启，需要开启请勾选，自动使用当前分身挑战星宿试炼">
                    <div slot="content">默认不开启，需要开启请勾选<br/>自动使用当前分身挑战星宿试炼</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="form2.starTrialEnabled"></el-checkbox>
            </el-form-item>

            <el-form-item label="自动宗门训练" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认不开启，需要开启请勾选，自动训练并出师">
                    <div slot="content">默认不开启，需要开启请勾选，自动训练并出师</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="form2.pupilEnabled"></el-checkbox>
            </el-form-item>

            <el-form-item label="自动砍树" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认不开启，需要开启请勾选，当晚4点-7点会自动砍树">
                    <div slot="content">默认不开启，需要砍树请勾选，当晚4点-7点会自动砍树<br/>PS: 没开分身前千万不要开启否则会封号</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="form2.chopTreeEnabled"></el-checkbox>
            </el-form-item>
            <el-form-item label="砍树桃子阈值：" v-if="form2.chopTreeEnabled">
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">桃子低于该数字时砍树停止，默认500</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>&nbsp;&nbsp;
              <el-input-number v-model="form2.chopStopNum" :min="100" :max="200000" label="砍树桃子阈值"></el-input-number>
            </el-form-item>
            <el-form-item label="砍树等级阈值：" v-if="form2.chopTreeEnabled">
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">人物等级大于等于该数字时砍树停止，默认9999</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>&nbsp;&nbsp;
              <el-input-number v-model="form2.chopStopLevel" :min="236" :max="9999" label="砍树等级阈值"></el-input-number>
            </el-form-item>
            <el-form-item label="元体装备属性设置：" v-if="form2.chopTreeEnabled">
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">可多选，第一个选择装备属性，第二个选择装备抗性</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>
              <div>
                <el-select v-model="form2.yuanChopStats" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in chopTreeStats" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="form2.yuanChopResistances" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in chopTreeResistances" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="阳神装备属性设置：" v-if="form2.chopTreeEnabled">
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">可多选，第一个选择装备属性，第二个选择装备抗性</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>
              <div>
                <el-select v-model="form2.yangChopStats" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in chopTreeStats" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="form2.yangChopResistances" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in chopTreeResistances" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="阴身装备属性设置：" v-if="form2.chopTreeEnabled">
              <span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">可多选，第一个选择装备属性，第二个选择装备抗性</div>
                  <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                </el-tooltip>
              </span>
              <div>
                <el-select v-model="form2.yingChopStats" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in chopTreeStats" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="form2.yingChopResistances" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
                  <el-option v-for="item in chopTreeResistances" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="自动斗法" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认不开启，开启后挂号期间斗法卷存量达到上限时会进行2次人机斗法">
                    <div slot="content">默认不开启<br/>开启后挂号期间斗法卷存量达到上限时会进行2次人机斗法</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="form2.fightEnabled" ></el-checkbox>
            </el-form-item>
            <el-form-item label="自动偷福地" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，关闭后将不再自动偷福地，请谨慎操作">
                    <div slot="content">默认开启<br/>关闭后将不再自动偷福地，请谨慎操作</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="form2.homelandEnabled" ></el-checkbox>
            </el-form-item>
            <el-form-item label="自动法则试炼" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，不可取消">
                    <div slot="content">默认开启，不可取消</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="fazeEnabled" disabled></el-checkbox>
            </el-form-item>
            <el-form-item label="自动仙友游历" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，不可取消">
                    <div slot="content">默认开启，不可取消</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="youliEnabled" disabled></el-checkbox>
            </el-form-item>
            <el-form-item label="自动看广告" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，不可取消">
                    <div slot="content">默认开启，不可取消<br/>自动观看树、青蛙、精怪、神通、法宝、宗门、聚灵阵广告</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="guanggaoEnabled" disabled></el-checkbox>
            </el-form-item>
            <el-form-item label="自动仙官领玉" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，不可取消">
                    <div slot="content">默认开启，不可取消<br/>挂号期间自动点击仙官弹窗领取仙玉</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="lingyuEnabled" disabled></el-checkbox>
            </el-form-item>
            <el-form-item label="自动妖盟任务" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认开启，不可取消">
                    <div slot="content">默认开启，不可取消<br/>自动砍价、请战等</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="kanjiaEnabled" disabled></el-checkbox>
            </el-form-item>
            <el-form-item label="自动推图" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start" content="默认不开启，需要开启请勾选">
                    <div slot="content">默认不开启，需要开启请勾选<br/>自动挑战冒险/真火秘境/镇妖塔<br/>开发中，敬请等待</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>&nbsp;&nbsp;
                <el-checkbox v-model="form2.challengeEnabled" disabled></el-checkbox>
            </el-form-item>
            <el-form-item label="修改福地规则：" ><br/>
              <div v-for="item in form2.rules">
                <el-checkbox v-model="item.isCheck" style="margin-right: 15px;"></el-checkbox>
                <el-select v-model="item.minItemLv" placeholder="请选择" style="margin-right: 15px;">
                  <el-option key="1" :label="1" :value="1"/>
                  <el-option key="2" :label="2" :value="2"/>
                  <el-option key="3" :label="3" :value="3"/>
                  <el-option key="4" :label="4" :value="4"/>
                  <el-option key="5" :label="5" :value="5"/>
                </el-select>
                {{ item.description }}
              </div>
            </el-form-item>

            <el-form-item label="顶号间隔" >
              <span>
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">玩家在挂号期间上号顶掉脚本<br/>脚本会在设定的时间达到后重新上号</div>
                    <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                  </el-tooltip>
                </span>
              <div>
                <el-radio-group v-model="form2.topSpacing">
                  <el-radio label="1" size="large">5 分钟</el-radio>
                  <el-radio label="2" size="large">10 分钟</el-radio>
                  <el-radio label="3" size="large">15 分钟</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>

          </el-form>

          <div slot="footer" style="display: flex;">
            <el-button @click="quit">返 回</el-button>
            <el-button type="primary" @click="submitEdit">修 改</el-button>
          </div>
      </div>
    </div>

  </div>

  

</template>

<script>
import axios from 'axios'
// import jsonFile from '@/assets/json/account.json';
// import qufu from '@/assets/json/qufu.json';
import {Message} from 'element-ui';

export default {
  name: "zh",
  data() {
    return {
      jieshao: '添加账号后，需联系作者激活才能进行账号管理。对于已录入的账号，请输入您的账号和密码完成身份验证，验证通过后即可访问相应功能。脚本具体功能详见下面配置。请注意，如需进行功能维护，请务必在每天21:00前完成，否则当日的修改将无效 --作者微信：llnunu',
      oldUserName: '',
      oldPassword: '',
      isSubmitting: false,
      tishi: "",
      form1: {
          username: '',
          password: '',
        },
        form2: {
          challengeEnabled: false,
          invadeEnabled: false,
          invadeIndex: 0,
          starTrialEnabled: false,
          pupilEnabled: false,
          chopTreeEnabled: false,
          chopStopNum: 100,
          chopStopLevel: 9999,
          fightEnabled: false,
          homelandEnabled: true,
          yuanChopStats: [],
          yuanChopResistances: [],
          yangChopStats: [],
          yangChopResistances: [],
          yingChopStats: [],
          yingChopResistances: [],
        },
        youliEnabled: true,
        fazeEnabled: true,
        guanggaoEnabled: true,
        kanjiaEnabled: true,
        lingyuEnabled: true,
        // 砍树相关
        chopTreeStats: [{ value: '5', label: '击晕' }, { value: '6', label: '暴击' }, { value: '7', label: '连击' }, 
        { value: '8', label: '闪避' }, { value: '9', label: '反击' },{ value: '10', label: '吸血' }],
        chopTreeResistances: [{ value: '11', label: '抗击晕' }, { value: '12', label: '抗暴击' }, { value: '13', label: '抗连击' }, 
        { value: '14', label: '抗闪避' }, { value: '15', label: '抗反击' },{ value: '16', label: '抗吸血' }],
        // 分身相关
        invadeIndexList: [{ value: 0, label: '元体' }, { value: 1, label: '阳神' }, { value: 2, label: '阴身' }],
    }
  },
  
  // beforeCreate() {
  //   document.querySelector('body').classList.add("overall");
  // },
  // beforeDestroy() {
  //   document.querySelector('body').classList.remove("overall");
  // },

  mounted() {

    if(this.$route.query.username) {
      this.form1.username = this.$route.query.username
      
    }
    if(this.$route.query.password) {
      this.form1.password = this.$route.query.password
    }
    
  },

  methods: {
  


    quit() {
      this.$router.push("/diy");
    },

    rzcx() {

      if(this.oldUserName == '') {
        Message.error({message: '请先验证'})
        return
      }
      this.$router.push({path: '/rz',
      query: { id: this.oldUserName , password: this.form1.password}});
    },

    verify() {
      this.postRequest("xundao/verify", this.form1).then(resp => {
        if (resp && resp.status == "200") {
          this.form2 = resp.obj
          this.form2.remainingDays = this.shengyutianshu(resp.obj.startDate)

          if(this.form2.remainingDays <= 2) {
            this.tishi = "（快到期了，请及时续费）";
          }

          if(this.form2.chopStopLevel == null) {
            this.form2.chopStopLevel = 9999;
          }

          this.oldUserName = resp.obj.username;
          this.oldPassword = resp.obj.password;
          this.form2.yuanChopStats = this.form2.yuanChopStats.map(String);
          this.form2.yuanChopResistances = this.form2.yuanChopResistances.map(String);
          this.form2.yangChopStats = this.form2.yangChopStats.map(String);
          this.form2.yangChopResistances = this.form2.yangChopResistances.map(String);
          this.form2.yingChopStats = this.form2.yingChopStats.map(String);
          this.form2.yingChopResistances = this.form2.yingChopResistances.map(String);
        }
      });
    },

    shengyutianshu(property) {
      if("9999-12-31" == property) {
        return "无限期";
      } else {
        var now = new Date();
        var year = now.getFullYear();
        var month = ('0' + (now.getMonth() + 1)).slice(-2); // getMonth() 是 0-based 的
        var day = ('0' + now.getDate()).slice(-2);
        let m = this.daysBetweenDates(property, year + '-' + month + '-' + day)

        var date1 = new Date(property);
        var date2 = new Date();

        if(date1 > date2) {
          return 30 + m;
        } else {
          let n = 30 - m;
          if(n < 0) {
            return 0;
          }
          return 30 - m;
        }
      }
    },

    daysBetweenDates(dateString1, dateString2) {
      // 将日期字符串转换为Date对象
      var date1 = new Date(dateString1);
      var date2 = new Date(dateString2);

      // 检查日期是否有效
      if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
          throw new Error('Invalid date');
      }

      // 计算两个日期之间的时间差（以毫秒为单位）
      var diffInMs = Math.abs(date2 - date1);

      // 转换为天数
      var diffInDays = diffInMs / (1000 * 60 * 60 * 24);

      return Math.floor(diffInDays);
    },

    submitEdit() {
      if (!this.isSubmitting)  {

        // 判断是否修改了账号密码
        if(this.form2.username != this.oldUserName || this.form2.password != this.oldPassword) {
          this.$confirm('检测到你替换了旧账号或旧密码，请确认是否继续修改！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              center: true,
              centered:true,
              type: 'warning'
            }).then(() => {
              this.isSubmitting = true;
              this.form2.oldUserName = this.oldUserName
              this.postRequest("xundao/editGR", this.form2).then(resp => {
                if (resp && resp.status == "200") {
                  this.isSubmitting = false;
                  
                  if(this.form2.username != this.oldUserName) {
                    this.$confirm('修改成功，请将替换的新账号告知管理员，方便后续续费，谢谢', '提示', {
                        cancelButtonText: '好的',
                        showConfirmButton: false, // 隐藏确定按钮
                        closeOnClickModal: false, // 禁用点击遮罩层关闭弹窗
                        center: true,
                        centered:true,
                        type: 'info'
                      }).then(() => { }).catch(() => { });
                  } else {
                    this.$confirm('已修改成功，可以退出网页啦!', '提示', {
                        cancelButtonText: '好的',
                        showConfirmButton: false, // 隐藏确定按钮
                        closeOnClickModal: false, // 禁用点击遮罩层关闭弹窗
                        center: true,
                        centered:true,
                        type: 'info'
                      }).then(() => { }).catch(() => { });
                  }

                }
              }).finally(() => {this.isSubmitting = false;});
            }).catch(() => {
                      
            });
        } else {
            this.isSubmitting = true;
            this.form2.oldUserName = this.oldUserName
            this.postRequest("xundao/editGR", this.form2).then(resp => {
              if (resp && resp.status == "200") {
                this.isSubmitting = false;
                this.$confirm('已修改成功，可以退出网页啦!', '提示', {
                  cancelButtonText: '好的',
                  showConfirmButton: false, // 隐藏确定按钮
                  closeOnClickModal: false, // 禁用点击遮罩层关闭弹窗
                  center: true,
                  centered:true,
                  type: 'info'
                }).then(() => { }).catch(() => { });
              }
            }).finally(() => {this.isSubmitting = false;});
        }
      }
    },
    
  }
}
</script>

<style>
/* 响应式样式 */
@media screen and (max-width: 768px) {
  .el-input, .el-button {
    width: 100%;
  }
}

.overall {
  position: absolute;
  content: ' ';
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  background-image: url("../assets/image.png");
  background-size: cover;
}

.custom-confirm {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}

@media screen and (max-width:750px) {
  .el-message-box{
  width:80% !important;}}

.el-message-box__btns {
  display: flex !important;
  justify-content: center !important;
}

</style>